/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import GlobalSearchWidget from '@ion/applications/src/globalsearch/GlobalSearchWidget';
import {dlsLayout} from '@ion/dls/src/theme/theme';
import DesktopHeaderContent from './DesktopHeaderContent';
import DesktopHeaderLogo from './DesktopHeaderLogo';
import styles from './DesktopHeader.module.scss';

const useStyles = makeStyles(() => ({
  customContainer : {
    height : dlsLayout('header', 'desktop')
  }
}));

/**
 * The Desktop Header component provides the application Header for the iOn Application
 * when view in Desktop Mode.
 */
export const DesktopHeader = () => {
  const classes = useStyles();
  return (
    <div className={`${styles.container} ${classes.customContainer}`}>
      <DesktopHeaderLogo />
      <div className={styles.search}>
        <GlobalSearchWidget from={'header'}
          isCtcAdminGlobalSearch
          isGlobalSearchMaxLength />
      </div>
      <DesktopHeaderContent />
    </div>
  );
};

export default React.memo(DesktopHeader);
